import { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import './../../index.css'
import systemContext from "../../_context/systemContext";
import { Spinner, Form, Modal, Card, Row, Col, Badge, Button } from 'react-bootstrap';
import { vscService } from "../../_services/vscService";
import { FaSync, FaFileExcel, FaPrint, FaFilter } from "react-icons/fa";
import Swal from 'sweetalert2';
import DataTable from 'react-data-table-component';
import * as XLSX from "xlsx-js-style";
import { saveAs } from "file-saver";
import 'bootstrap/dist/css/bootstrap.min.css';
import { AiOutlineEye } from "react-icons/ai";

const VentasAutorizadas = () => {    
    const navigate = useNavigate();
    const SystemContext = useContext(systemContext);
    const user = SystemContext.getUser();
    const [loading, setLoading] = useState(false);
    const [ventas, setVentas] = useState([]);
    const [mesSeleccionado, setMesSeleccionado] = useState(new Date().getMonth() + 1);
    const [anioSeleccionado, setAnioSeleccionado] = useState(new Date().getFullYear());
    const [tipoSeleccionado, setTipoSeleccionado] = useState('VSC');
    const [filterText, setFilterText] = useState('');
    const [resetPaginationToggle, setResetPaginationToggle] = useState(false);
    const [showLoader, setShowLoader] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [detalleRow, setDetalleRow] = useState(null);
    const [movimientos, setMovimientos] = useState([]);
    const [loadingMovimientos, setLoadingMovimientos] = useState(false);

    const meses = [
        { valor: 1, descripcion: 'Enero' },
        { valor: 2, descripcion: 'Febrero' },
        { valor: 3, descripcion: 'Marzo' },
        { valor: 4, descripcion: 'Abril' },
        { valor: 5, descripcion: 'Mayo' },
        { valor: 6, descripcion: 'Junio' },
        { valor: 7, descripcion: 'Julio' },
        { valor: 8, descripcion: 'Agosto' },
        { valor: 9, descripcion: 'Septiembre' },
        { valor: 10, descripcion: 'Octubre' },
        { valor: 11, descripcion: 'Noviembre' },
        { valor: 12, descripcion: 'Diciembre' }
    ];
    
    const generarAnios = () => {
        const anios = [];
        const anioActual = new Date().getFullYear();
        
        // 15 años hacia atrás desde el año actual
        for (let i = 15; i >= 0; i--) {
            anios.push(anioActual - i);
        }
        
        return anios;
    };

    const aniosDisponibles = generarAnios();

    // Loader Modal
    const LoaderModal = ({ show }) => {
        return (
            <Modal show={show} backdrop="static" keyboard={false} centered className="nova-loader-modal">
                <Modal.Body className="text-center p-4">
                    <Spinner animation="border" variant="primary" size="lg" className="mb-3" />
                    <h6 className="text-primary mb-1">Cargando información...</h6>
                    <small className="text-muted">Por favor espere</small>
                </Modal.Body>
            </Modal>
        );
    };

    // Filtrar datos
    const filteredItems = ventas.filter(item => {
        const searchText = filterText.toLowerCase();
        return (
            item.ruta.toLowerCase().includes(searchText) ||
            item.cliente.toLowerCase().includes(searchText) ||
            item.nombreCte.toLowerCase().includes(searchText) ||
            item.canal.toLowerCase().includes(searchText)
        );
    });

    // Componente del buscador compacto
    const subHeaderComponent = (
        <div className="nova-table-search compact">
            <div className="d-flex align-items-center gap-2">
                <FaFilter className="text-muted" size={14} />
                <input
                    type="text"
                    placeholder="Buscar ruta, cliente, canal..."
                    className="nova-search-input compact"
                    value={filterText}
                    onChange={e => setFilterText(e.target.value)}
                />
                <div className="nova-search-results compact">
                    {filteredItems.length} de {ventas.length}
                    {filterText && (
                        <button 
                            className="nova-clear-search ms-2"
                            onClick={() => {
                                setFilterText('');
                                setResetPaginationToggle(!resetPaginationToggle);
                            }}
                            title="Limpiar búsqueda"
                        >
                            ×
                        </button>
                    )}
                </div>
            </div>
        </div>
    );
    
    const columnasDataTable = [
        {
            name: '',
            width: '30px',
            cell: row => (
                <button
                className="btn btn-sm btn-outline-primary border-0"
                onClick={() => handleOpenModal(row)}
                title="Ver detalle"
                >
                <AiOutlineEye size={18} />
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: 'Ruta',
            selector: row => row.ruta,
            sortable: true,
            width: '80px'
        },
        {
            name: 'Cliente',
            selector: row => row.cliente,
            sortable: true,
            width: '90px'
        },
        {
            name: 'Nombre',
            selector: row => row.nombreCte,
            sortable: true,
            width: '220px',
            cell: row => (
                <span 
                    className="text-truncate d-block" 
                    title={row.nombreCte}
                    style={{ cursor: 'help' }}
                >
                    {row.nombreCte}
                </span>
            )
        },
        {
            name: 'Canal',
            selector: row => row.canal,
            sortable: true,
            width: '180px',
            cell: row => (
                <span 
                    className="text-truncate d-block" 
                    title={row.canal}
                    style={{ cursor: 'help' }}
                >
                    {row.canal}
                </span>
            )
        },
        {
            name: 'Venta $',
            selector: row => row.venta,
            sortable: true,
            cell: row => (
                <span className="text-end d-block">
                    ${row.venta.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '100px'
        },
        {
            name: 'Venta Kg',
            selector: row => row.ventaKg,
            sortable: true,
            cell: row => (
                <span className="text-end d-block">
                    {row.ventaKg.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '100px'
        },
        {
            name: 'VSC $',
            selector: row => row.vscPesos,
            sortable: true,
            cell: row => (
                <span className="text-end d-block">
                    ${row.vscPesos.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '100px'
        },
        {
            name: 'VSC Kg',
            selector: row => row.vscKilos,
            sortable: true,
            cell: row => (
                <span className="text-end d-block">
                    {row.vscKilos.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '100px'
        },
        {
            name: 'VSC inicial',
            selector: row => row.vscAutorizadaInicial,
            sortable: true,
            cell: row => (
                <span className="text-end d-block fw-bold">
                    ${row.vscAutorizadaInicial.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '120px'
        },
        {
            name: 'VSC disponible',
            selector: row => row.vscAutorizada,
            sortable: true,
            cell: row => (
                <span className="text-end d-block fw-bold">
                    ${row.vscAutorizada.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '120px'
        },
        {
            name: 'Aplicado',
            selector: row => row.vscAutorizadaConsumido,
            sortable: true,
            cell: row => (
                <span className="text-end d-block fw-bold">
                    ${row.vscAutorizadaConsumido.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '120px'
        },
        // {
        //     name: 'Pedido',
        //     selector: row => row.NumPedido,
        //     sortable: true,
        //     width: '100px'
        // },
        // {
        //     name: 'Factura',
        //     selector: row => row.NumFactura,
        //     sortable: true,
        //     width: '100px'
        // },
    ];

    const columnasDataTableCF = [
        {
            name: '',
            width: '30px',
            cell: row => (
                <button
                className="btn btn-sm btn-outline-primary border-0"
                onClick={() => handleOpenModal(row)}
                title="Ver detalle"
                >
                <AiOutlineEye size={18} />
                </button>
            ),
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
        {
            name: 'Ruta',
            selector: row => row.ruta,
            sortable: true,
            width: '80px'
        },
        {
            name: 'Cliente',
            selector: row => row.cliente,
            sortable: true,
            width: '90px'
        },
        {
            name: 'Nombre',
            selector: row => row.nombreCte,
            sortable: true,
            width: '220px',
            cell: row => (
                <span 
                    className="text-truncate d-block" 
                    title={row.nombreCte}
                    style={{ cursor: 'help' }}
                >
                    {row.nombreCte}
                </span>
            )
        },
        {
            name: 'Canal',
            selector: row => row.canal,
            sortable: true,
            width: '180px',
            cell: row => (
                <span 
                    className="text-truncate d-block" 
                    title={row.canal}
                    style={{ cursor: 'help' }}
                >
                    {row.canal}
                </span>
            )
        },
        {
            name: 'Venta $',
            selector: row => row.venta,
            sortable: true,
            cell: row => (
                <span className="text-end d-block">
                    ${row.venta.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '100px'
        },
        {
            name: 'Venta Kg',
            selector: row => row.ventaKg,
            sortable: true,
            cell: row => (
                <span className="text-end d-block">
                    {row.ventaKg.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '100px'
        },
        {
            name: 'VSC $',
            selector: row => row.vscPesos,
            sortable: true,
            cell: row => (
                <span className="text-end d-block">
                    ${row.vscPesos.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '100px'
        },
        {
            name: 'VSC Kg',
            selector: row => row.vscKilos,
            sortable: true,
            cell: row => (
                <span className="text-end d-block">
                    {row.vscKilos.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '100px'
        },
        {
            name: 'CF inicial',
            selector: row => row.vscAutorizadaCambioFisicoInicial,
            sortable: true,
            cell: row => (
                <span className="text-end d-block fw-bold">
                    ${row.vscAutorizadaCambioFisicoInicial.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '120px'
        },
        {
            name: 'CF disponible',
            selector: row => row.vscAutorizadaCambioFisico,
            sortable: true,
            cell: row => (
                <span className="text-end d-block fw-bold">
                    ${row.vscAutorizadaCambioFisico.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '120px'
        },
        {
            name: 'Aplicado',
            selector: row => row.vscAutorizadaCambioFisicoConsumido,
            sortable: true,
            cell: row => (
                <span className="text-end d-block fw-bold">
                    ${row.vscAutorizadaCambioFisicoConsumido.toLocaleString('es-MX', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                </span>
            ),
            width: '120px'
        },
        // {
        //     name: 'Pedido',
        //     selector: row => row.NumPedido,
        //     sortable: true,
        //     width: '100px'
        // },
        // {
        //     name: 'Factura',
        //     selector: row => row.NumFactura,
        //     sortable: true,
        //     width: '100px'
        // },
    ];

    const columnasMovimientos = [
    {
        name: 'Fecha',
        selector: row => row.fecha,
        sortable: true,
        cell: row => (
        <span>
            {new Date(row.fecha).toLocaleString('es-MX')}
        </span>
        ),
        width: '180px'
    },
    {
        name: 'Tipo',
        selector: row => row.tipoMovimiento,
        sortable: true,
        cell: row => (
        <span className={`badge ${
            row.tipoMovimiento === 'CARGO' 
            ? 'bg-danger' 
            : 'bg-success'
        }`}>
            {row.tipoMovimiento}
        </span>
        ),
        width: '80px'
    },
    {
        name: 'Monto',
        selector: row => row.monto,
        sortable: true,
        right: true,
        cell: row => (
        <span className="fw-bold">
            ${row.monto.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
        </span>
        ),
        width: '120px'
    },
    {
        name: 'Saldo Antes',
        selector: row => row.saldoAntes,
        sortable: true,
        right: true,
        cell: row => (
        <span>
            ${row.saldoAntes.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
        </span>
        ),
        width: '120px'
    },
    {
        name: 'Saldo Después',
        selector: row => row.saldoDespues,
        sortable: true,
        right: true,
        cell: row => (
        <span className="fw-bold text-primary">
            ${row.saldoDespues.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
        </span>
        ),
        width: '140px'
    },
    {
        name: 'Pedido',
        selector: row => row.numPedido,
        sortable: true,
        width: '120px'
    },
    {
        name: 'Factura',
        selector: row => row.numFactura,
        sortable: true,
        width: '120px'
    },
    {
        name: 'Usuario',
        selector: row => row.usuario,
        sortable: true,
        width: '140px'
    }
    ];

    const conditionalRowStyles = [
    {
        when: row => row.TipoMovimiento === 'CARGO',
        style: {
        backgroundColor: 'rgba(255, 0, 0, 0.05)',
        },
    },
    {
        when: row => row.TipoMovimiento === 'ABONO',
        style: {
        backgroundColor: 'rgba(0, 128, 0, 0.05)',
        },
    },
    ];
    
    const customStyles = {
        headRow: {
            style: {
                backgroundColor: '#f8f9fa',
                borderBottom: '2px solid #dee2e6',
                fontSize: '0.75rem',
                fontWeight: 'bold',
                minHeight: '35px'
            },
        },
        headCells: {
            style: {
                paddingLeft: '6px',
                paddingRight: '6px',
                fontSize: '0.7rem',
                fontWeight: 'bold'
            },
        },
        cells: {
            style: {
                paddingLeft: '6px',
                paddingRight: '6px',
                fontSize: '0.7rem',
            },
        },
        rows: {
            style: {
                fontSize: '0.7rem',
                minHeight: '35px',
            },
        },
        pagination: {
            style: {
                fontSize: '0.7rem',
                padding: '8px'
            },
        },
    };
    
    const cargarVentasAutorizadas = async (mes, anio, tipo) => {
        setShowLoader(true);
        setLoading(true);
        try {
            // 🔴 Pasar ambos parámetros al servicio
            const respuesta = await vscService.getVentasAutorizadasPorMes(mes, anio, tipo);            
            console.log('Datos cargados:', { 
                mes, 
                anio, 
                tipo,
                cantidad: respuesta?.content?.ventasAutorizadas?.length || 0 
            });
            
            if (respuesta.status === "OK") {
                const ventasData = respuesta.content.ventasAutorizadas || [];
                setVentas(ventasData);
            } else {
                console.warn('Respuesta no OK:', respuesta);
                setVentas([]);
            }
        } catch (error) {
            console.error('Error al cargar ventas autorizadas:', error);
            Swal.fire({
                position: "top-end",
                icon: "error",
                title: "Error al cargar ventas autorizadas",
                showConfirmButton: false,
                timer: 2000,
                customClass: {
                    popup: 'nova-swal-popup'
                }
            });
            setVentas([]);
        } finally {
            setLoading(false);
            setShowLoader(false);
        }
    };

    const getMovimientos = async (row) => {
        setLoadingMovimientos(true);
        const json = {
            ruta: row.ruta,
            cliente: row.cliente,
            anio: anioSeleccionado,
            mes: mesSeleccionado,
            tipo: tipoSeleccionado
        };
        try {
            const res = await vscService.postMovimientosVSC(json);
            const data = res.content?.movimientos || [];
            setMovimientos(data);
        } catch (error) {
            console.error(error);
            setMovimientos([]);
        } finally {
            setLoadingMovimientos(false);
        }
    };
    
    useEffect(() => {
        const mesActual = new Date().getMonth() + 1;
        const anioActual = new Date().getFullYear();
        const tipoActual = 'VSC';        
        setMesSeleccionado(mesActual);
        setAnioSeleccionado(anioActual);
        setTipoSeleccionado(tipoActual);        
        cargarVentasAutorizadas(mesActual, anioActual, tipoActual);
    }, []);
    
    const handleMesChange = (e) => {
        const nuevoMes = parseInt(e.target.value);
        setMesSeleccionado(nuevoMes);
        cargarVentasAutorizadas(nuevoMes, anioSeleccionado, tipoSeleccionado);
    };
   
    const handleAnioChange = (e) => {
        const nuevoAnio = parseInt(e.target.value);
        setAnioSeleccionado(nuevoAnio);
        cargarVentasAutorizadas(mesSeleccionado, nuevoAnio, tipoSeleccionado);
    };

    const handleTipoChange = (e) => {
        const nuevoTipo = e.target.value;
        setTipoSeleccionado(nuevoTipo);
        cargarVentasAutorizadas(mesSeleccionado, anioSeleccionado, nuevoTipo);
    };
    
    const handleRecargar = () => {
        cargarVentasAutorizadas(mesSeleccionado, anioSeleccionado, tipoSeleccionado);
    };

    // Calcular totales
    const calcularTotales = () => {
        return {
            totalVenta: ventas.reduce((sum, item) => sum + item.venta, 0),
            totalVentaKg: ventas.reduce((sum, item) => sum + item.ventaKg, 0),
            totalVscPesos: ventas.reduce((sum, item) => sum + item.vscPesos, 0),
            totalVscKilos: ventas.reduce((sum, item) => sum + item.vscKilos, 0),
            totalVscAutorizada: ventas.reduce((sum, item) => sum + item.vscAutorizada, 0),
            totalVscCambioFisico: ventas.reduce((sum, item) => sum + item.vscAutorizadaCambioFisico, 0)
        };
    };

    const totales = calcularTotales();

    const exportarExcelVentas = (ventas) => {
        if (!ventas?.length) return;

        const esVSC = tipoSeleccionado === 'VSC';
        const headers = [
            "Ruta",
            "Cve cliente",
            "Cliente",
            "Canal",
            "Año",
            "Mes",
            "Venta ($)",
            "Venta KG",
            "VSC ($)",
            ...(esVSC 
                ? ["Venta sin cargo inicial", "Venta sin cargo disponible", "Venta sin cargo consumida"]
                : ["Cambio físico inicial", "Cambio físico disponible", "Cambio físico consumido"]
            ),
            "Numero de pedido",
            "Numero de factura"
        ];

        const rows = ventas.map(v => [
            v.ruta,
            v.cliente,
            v.nombreCte,
            v.canal,
            v.año,
            v.mes,
            v.venta,
            v.ventaKg,
            v.vscPesos,
            ...(esVSC 
                ? [v.vscAutorizadaInicial, v.vscAutorizada, v.vscAutorizadaConsumido]
                : [v.vscAutorizadaCambioFisicoInicial, v.vscAutorizadaCambioFisico, v.vscAutorizadaCambioFisicoConsumido]
            ),
            v.NumPedido,
            v.NumFactura
        ]);

        const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);

        /* Estilo encabezados */
        headers.forEach((_, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
            ws[cellRef].s = {
            font: { bold: true, color: { rgb: "FFFFFF" } },
            fill: { fgColor: { rgb: "305496" } },
            alignment: { horizontal: "center", vertical: "center" },
            border: {
                top: { style: "thin" },
                bottom: { style: "thin" },
                left: { style: "thin" },
                right: { style: "thin" }
            }
            };
        });

        /* 💵 Formato moneda */
        for (let r = 1; r <= rows.length; r++) {
            ["G", "H", "I", "J", "K"].forEach(col => {
            const cell = ws[`${col}${r + 1}`];
            if (cell) cell.z = '"$"#,##0.00';
            });
        }

        /* 📏 Auto ancho de columnas basado en contenido */
        const colWidths = headers.map((header, colIndex) => {
        const maxLength = Math.max(
            header.length,
            ...rows.map(row =>
            row[colIndex] ? row[colIndex].toString().length : 0
            )
        );
        return { wch: maxLength + 3 };
        });
        ws["!cols"] = colWidths;    

        /* 🔍 Autofiltro */
        ws["!autofilter"] = {
            ref: `A1:H${rows.length + 1}`
        };

        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Ventas Autorizadas");

        XLSX.writeFile(
            wb,
            `Ventas_Autorizadas_${new Date().toISOString().slice(0, 10)}.xlsx`
        );
    };

    const exportarExcelMovimientos = () => {
        if (!movimientos?.length) return;
        const headers = [
            "Fecha",
            "Ruta",
            "Cliente",
            "Tipo",
            "Movimiento",
            "Monto",
            "Saldo antes",
            "Saldo después",
            "Pedido",
            "Factura",
            "Descripción",
            "Usuario"
        ];
        const rows = movimientos.map(m => [
            m.fecha ? new Date(m.fecha).toLocaleString('es-MX') : "",
            m.ruta,
            m.cliente,
            m.tipo,
            m.tipoMovimiento,
            m.monto,
            m.saldoAntes,
            m.saldoDespues,
            m.numPedido,
            m.numFactura,
            m.descripcion,
            m.usuario
        ]);
        const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        headers.forEach((_, colIndex) => {
            const cellRef = XLSX.utils.encode_cell({ r: 0, c: colIndex });
            ws[cellRef].s = {
                font: { bold: true, color: { rgb: "FFFFFF" } },
                fill: { fgColor: { rgb: "305496" } },
                alignment: { horizontal: "center", vertical: "center" }
            };
        });
        for (let r = 1; r <= rows.length; r++) {
            ["F", "G", "H"].forEach(col => {
                const cell = ws[`${col}${r + 1}`];
                if (cell) cell.z = '"$"#,##0.00';
            });
        }
        ws["!cols"] = headers.map((header, colIndex) => {
            const maxLength = Math.max(
                header.length,
                ...rows.map(row => row[colIndex] ? row[colIndex].toString().length : 0)
            );
            return { wch: maxLength + 3 };
        });
        // ws["!autofilter"] = {
        //     ref: `A1:L${rows.length + 1}`
        // };
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, "Movimientos");
        XLSX.writeFile(
            wb,
            `Movimientos_${detalleRow?.ruta || detalleRow?.Ruta}_${detalleRow?.cliente || detalleRow?.Cliente}_${new Date().toISOString().slice(0, 10)}.xlsx`
        );
    };

    const handleOpenModal = (row) => {
        setDetalleRow(row);
        setShowModal(true);
        getMovimientos(row);
    }

    const handleCloseModal = () => {
        setShowModal(false);
        setDetalleRow(null);
    };

    return (
        <div className="nova-dashboard-balanced">
            <LoaderModal show={showLoader} />
            {/* Header compacto */}
            <div className="nova-page-header compact">
                <div className="d-flex align-items-center w-100">

                    {/* IZQUIERDA */}
                    <div>
                        <h4 className="nova-page-title mb-1">Ventas Autorizadas</h4>
                        <p className="nova-page-subtitle mb-0">Consulta mensual de ventas autorizadas</p>
                    </div>

                    {/* CENTRO */}
                    <div className="d-flex align-items-end gap-3 mx-auto">
                        <Form.Group className="mb-0">
                            <Form.Label className="small fw-bold mb-1">Año</Form.Label>
                            <Form.Select
                                value={anioSeleccionado}
                                onChange={handleAnioChange}
                                size="sm"
                                style={{ width: '100px', height: '25px', fontSize: '12px' }}
                            >
                                {aniosDisponibles.map(anio => (
                                    <option key={anio} value={anio}>{anio}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-0">
                            <Form.Label className="small fw-bold mb-1">Mes</Form.Label>
                            <Form.Select
                                value={mesSeleccionado}
                                onChange={handleMesChange}
                                size="sm"
                                style={{ width: '130px', height: '25px', fontSize: '12px' }}
                            >
                                {meses.map(mes => (
                                    <option key={mes.valor} value={mes.valor}>{mes.descripcion}</option>
                                ))}
                            </Form.Select>
                        </Form.Group>

                        <Form.Group className="mb-0">
                            <Form.Label className="small fw-bold mb-1">Tipo</Form.Label>
                            <Form.Select
                                value={tipoSeleccionado}
                                onChange={handleTipoChange}
                                size="sm"
                                style={{ width: '140px', height: '25px', fontSize: '12px' }}
                            >
                            <option key='VSC' value='VSC'>Venta sin cargo</option>
                            <option key='CF' value='CF'>Cambio físico</option>
                            </Form.Select>
                        </Form.Group>

                        <Button 
                            variant="outline-primary" 
                            size="sm"
                            onClick={handleRecargar}
                            disabled={loading}
                            className="mt-3"
                        >
                            <FaSync className={loading ? "spinning" : ""} />
                        </Button>
                    </div>

                    {/* DERECHA */}
                    <div className="ms-auto">
                        <Button
                            onClick={() => exportarExcelVentas(ventas)}
                            disabled={loading || !ventas?.length}
                            style={{
                                backgroundColor: "#217346",
                                borderColor: "#217346",
                                color: "white",
                                fontWeight: "600",
                                fontSize: "0.85rem",
                                padding: "6px 12px",
                                borderRadius: "6px",
                                display: "flex",
                                alignItems: "center",
                                gap: "8px",
                                boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                marginTop: "18px"
                            }}
                            onMouseEnter={e => e.target.style.backgroundColor = "#1a5c36"}
                            onMouseLeave={e => e.target.style.backgroundColor = "#217346"}
                        >
                            <img src="/images/excel.png" alt="Excel" style={{ width: 18, height: 18 }} />
                            Generar Excel
                        </Button>
                    </div>

                </div>
            </div>
            <div className="nova-grid-container" style={{ margin: '0 0px 5px 0px' }}>
                <Card className="nova-summary-card">
                    <Card.Body className="p-3">
                        <Row className="g-3">
                            <Col>
                                <div className="nova-summary-item text-center">
                                    <small className="text-muted d-block">Periodo</small>
                                    <strong className="text-primary">
                                        {meses.find(m => m.valor === mesSeleccionado)?.descripcion} {anioSeleccionado}
                                    </strong>
                                </div>
                            </Col>
                            
                            <Col>
                                <div className="nova-summary-item text-center">
                                    <small className="text-muted d-block">Total Venta</small>
                                    <strong className="text-primary">
                                        ${totales.totalVenta.toLocaleString('es-MX', { minimumFractionDigits: 0 })}
                                    </strong>
                                </div>
                            </Col>
                            <Col>
                                <div className="nova-summary-item text-center">
                                    <small className="text-muted d-block">VSC Autorizada</small>
                                    <strong className="text-success">
                                        ${totales.totalVscAutorizada.toLocaleString('es-MX', { minimumFractionDigits: 0 })}
                                    </strong>
                                </div>
                            </Col>
                            <Col>
                                <div className="nova-summary-item text-center">
                                    <small className="text-muted d-block">Cambio Físico</small>
                                    <strong className="text-info">
                                        ${totales.totalVscCambioFisico.toLocaleString('es-MX', { minimumFractionDigits: 0 })}
                                    </strong>
                                </div>
                            </Col>
                            <Col>
                                <div className="nova-summary-item text-center">
                                    <small className="text-muted d-block">Registros</small>
                                    <strong className="text-warning">
                                        {ventas.length.toLocaleString()}
                                    </strong>
                                </div>
                            </Col>
                        </Row>
                    </Card.Body>
                </Card>
            </div>
            <div className="nova-grid-container" style={{ margin: '0 0px' }}>
                <Card className="nova-data-card">
                    <Card.Header className="py-2 px-3 d-flex justify-content-between align-items-center">
                        <h6 className="mb-0 fw-bold">Detalle de Ventas</h6>
                        <small className="text-muted">
                            {meses.find(m => m.valor === mesSeleccionado)?.descripcion} {anioSeleccionado} • {filteredItems.length} registros
                        </small>
                    </Card.Header>
                    <Card.Body className="p-0">
                        {loading && ventas.length === 0 ? (
                            <div className="text-center py-4">
                                <Spinner animation="border" variant="primary" size="sm" />
                                <p className="mt-2 text-muted small">Cargando ventas autorizadas...</p>
                            </div>
                        ) : ventas.length === 0 ? (
                            <div className="text-center py-4">
                                <p className="text-muted small">
                                    No hay ventas autorizadas para {meses.find(m => m.valor === mesSeleccionado)?.descripcion} {anioSeleccionado}
                                </p>
                            </div>
                        ) : (
                            <DataTable
                                columns={tipoSeleccionado === 'VSC' ? columnasDataTable : columnasDataTableCF}
                                data={filteredItems}
                                customStyles={customStyles}
                                pagination
                                paginationPerPage={10}
                                paginationRowsPerPageOptions={[10, 20, 50, 100,filteredItems.length]}
                                noDataComponent={<div className="text-center py-4 small">No hay datos para mostrar</div>}
                                highlightOnHover
                                striped
                                responsive
                                defaultSortFieldId={1}
                                defaultSortAsc={false}
                                subHeader
                                subHeaderComponent={subHeaderComponent}
                                persistTableHead
                                dense
                            />
                        )}
                    </Card.Body>
                </Card>
            </div>
            {/* Modal que muestra el detalle */}
            <Modal
                show={showModal}
                onHide={handleCloseModal}
                size="xl"
                centered
            >
            <Modal.Header closeButton>
                <Modal.Title>Detalle de movimientos</Modal.Title>
            </Modal.Header>
            <Modal.Body>
            {detalleRow && (
                <>
                {/* Header info */}
                 <div className="d-flex justify-content-between align-items-center mb-2">
                    <h6 className="mb-0 text-secondary fw-bold">
                        Información del cliente
                    </h6>
                    <Button
                        onClick={exportarExcelMovimientos}
                        disabled={loadingMovimientos || !movimientos?.length}
                        style={{
                            backgroundColor: "#217346",
                            borderColor: "#217346",
                            color: "white",
                            fontWeight: "600",
                            fontSize: "0.85rem",
                            padding: "6px 12px",
                            borderRadius: "6px",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                            boxShadow: "0 1px 3px rgba(0,0,0,0.2)"
                        }}
                        onMouseEnter={e => e.currentTarget.style.backgroundColor = "#1a5c36"}
                        onMouseLeave={e => e.currentTarget.style.backgroundColor = "#217346"}
                    >
                        <img
                            src="/images/excel.png"
                            alt="Excel"
                            style={{ width: 18, height: 18 }}
                        />
                        Generar Excel
                    </Button>
                </div>
                <div className="row g-2 mb-3">
                    <div className="col-md-2">
                        <div
                            className="rounded shadow-sm px-3 py-2 h-100"
                            style={{
                                backgroundColor: '#f4f6f9',
                                borderLeft: '3px solid #6c757d'
                            }}
                        >
                            <div className="small text-muted">
                                Ruta
                            </div>
                            <div className="fw-bold">
                                {detalleRow.ruta}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-2">
                        <div
                            className="rounded shadow-sm px-3 py-2 h-100"
                            style={{
                                backgroundColor: '#f4f6f9',
                                borderLeft: '3px solid #6c757d'
                            }}
                        >
                            <div className="small text-muted">
                                Cliente
                            </div>
                            <div className="fw-bold">
                                {detalleRow.cliente}
                            </div>
                        </div>
                    </div>
                    <div className="col-md-8">
                        <div
                            className="rounded shadow-sm px-3 py-2 h-100"
                            style={{
                                backgroundColor: '#f4f6f9',
                                borderLeft: '3px solid #6c757d'
                            }}
                        >
                            <div className="small text-muted">
                                Nombre
                            </div>
                            <div
                                className="fw-bold"
                                style={{
                                    whiteSpace: 'nowrap',
                                    overflow: 'hidden',
                                    textOverflow: 'ellipsis'
                                }}
                            >
                                {detalleRow.nombreCte}
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                {/* Loader */}
                {loadingMovimientos ? (
                    <div className="text-center py-4">
                    <div className="spinner-border text-primary"></div>
                    <div className="mt-2 small text-muted">Cargando movimientos...</div>
                    </div>
                ) : (
                    <DataTable
                    columns={columnasMovimientos}
                    data={movimientos}
                    conditionalRowStyles={conditionalRowStyles}
                    pagination
                    dense
                    striped
                    highlightOnHover
                    responsive
                    noDataComponent={
                        <div className="text-center py-4 text-muted">
                        Sin movimientos registrados
                        </div>
                    }
                    />
                )}
                </>
            )}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseModal}>
                Cerrar
                </Button>
            </Modal.Footer>
            </Modal>
            {/* Agregar estos estilos CSS */}
            <style jsx>{`
                .spinning {
                    animation: spin 1s linear infinite;
                }
                @keyframes spin {
                    from { transform: rotate(0deg); }
                    to { transform: rotate(360deg); }
                }
                .nova-summary-item {
                    padding: 8px;
                    border-radius: 6px;
                    background: #f8f9fa;
                }
                .nova-page-header.compact {
                    padding: 20px 20px 10px 20px;
                }
                .nova-search-input.compact {
                    height: 32px;
                    font-size: 0.8rem;
                }
                .nova-table-search.compact {
                    padding: 8px 12px;
                }
                .periodo-display {
                    font-size: 0.9rem;
                    color: #6c757d;
                }
            `}</style>
        </div>
        
    );
};

export default VentasAutorizadas;